import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable react/jsx-no-target-blank */

/* eslint-disable no-param-reassign */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Alert, CheckboxItem, Button as BoltButton } from '@sainsburys-tech/bolt';
import { formatPrice, setLocalStorageWithExpiry, getLocalStorageWithExpiry } from '@sainsburys-tech/boltui-utils';
import careTypes from './config/careTypes';
import Button from '../../containers/Button/Button';
import * as actions from '../../actions';
import { onWarrantyIPDLinkClicked } from '../../helpers/tracking';
import { flatten } from '../../helpers';
import * as Styled from '../TrolleyItem/TrolleyItem.styles';

var Price = function Price(_ref) {
  var quantity = _ref.quantity,
      price = _ref.price,
      isMonthlyCare = _ref.isMonthlyCare,
      dataTest = _ref.dataTest,
      direction = _ref.direction;
  return /*#__PURE__*/React.createElement(Styled.ItemPrice, {
    direction: direction
  }, /*#__PURE__*/React.createElement("span", {
    "data-test": "".concat(dataTest, "-price")
  }, formatPrice(price)), quantity > 1 && /*#__PURE__*/React.createElement("small", null, isMonthlyCare ? 'per item' : 'each'));
};

var ProductCareSelectedCheckboxLink = function ProductCareSelectedCheckboxLink(_ref2) {
  var _careTypes$careType;

  var links = _ref2.links,
      dataTest = _ref2.dataTest,
      careType = _ref2.careType;
  var leafletCopy = ((_careTypes$careType = careTypes[careType]) === null || _careTypes$careType === void 0 ? void 0 : _careTypes$careType.leafletCopy) || 'Terms & Conditions';
  return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("strong", null, "I have read the", ' ', /*#__PURE__*/React.createElement("a", {
    href: links.ipid,
    target: "_blank",
    rel: "noreferrer",
    dataTest: "".concat(dataTest, "-IPID")
  }, "Insurance Product Information Document (IPID)"), ' ', "and the", ' ', /*#__PURE__*/React.createElement("a", {
    href: links.leaflet,
    target: "_blank",
    rel: "noreferrer",
    dataTest: "".concat(dataTest, "-terms")
  }, leafletCopy), ". The product meets my demands and needs."));
};

export var WarrantyItem = function WarrantyItem(_ref3) {
  var _included$find;

  var partNumber = _ref3.partNumber,
      quantity = _ref3.quantity,
      itemType = _ref3.itemType,
      moduleIndex = _ref3.moduleIndex,
      productInfo = _ref3.productInfo,
      trackingOptions = _ref3.trackingOptions,
      onClick = _ref3.onClick,
      updateTrolleyField = _ref3.updateTrolleyField,
      careData = _ref3.careData,
      hideMonthlyCareCTA = _ref3.hideMonthlyCareCTA,
      dataTest = _ref3['data-test'];

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      termCheck = _useState2[0],
      setTermCheck = _useState2[1];

  var isMonthlyCare = careData.type.startsWith('monthly_care');
  var attributes = productInfo.data.attributes,
      included = productInfo.included;
  var price = isMonthlyCare ? attributes.price.now : (_included$find = included.find(function (item) {
    return item.type === 'prices';
  })) === null || _included$find === void 0 ? void 0 : _included$find.attributes.now;

  var onClickAddItem = function onClickAddItem() {
    var info = {
      id: partNumber,
      quantity: quantity,
      price: price,
      moduleIndex: moduleIndex,
      itemType: itemType,
      origin: 'AttLb:warrantiesTickBox'
    };

    if (termCheck) {
      updateTrolleyField(partNumber, actions.TROLLEY_FIELD_QUANTITY, quantity);
      onClick(info);
    }
  };

  var onClickAddMonthly = function onClickAddMonthly() {
    var storagekey = 'addedMonthlyCares';
    var addedMonthlyCares = getLocalStorageWithExpiry(storagekey);
    var trolley = [];

    if (addedMonthlyCares) {
      trolley = addedMonthlyCares;
    }

    trolley.push({
      parentProductId: careData.hostId,
      careId: partNumber,
      quantity: quantity
    });
    setLocalStorageWithExpiry(storagekey, trolley, 86400000); // 24h = 86400000

    window.location.href = "/basket";
  };

  trackingOptions.itemId = partNumber;
  var trackingInfo = {
    isMonthlyCare: isMonthlyCare,
    products: [{
      id: trackingOptions.mainProductId
    }, {
      id: partNumber
    }]
  };

  var handleIPDClick = function handleIPDClick() {
    onWarrantyIPDLinkClicked(trackingInfo);
  };

  return /*#__PURE__*/React.createElement(Styled.CareBox, {
    "data-test": dataTest
  }, /*#__PURE__*/React.createElement(Styled.CareProductWrapper, null, /*#__PURE__*/React.createElement(Styled.CareNameWrapper, null, /*#__PURE__*/React.createElement("h4", null, attributes.name), isMonthlyCare && /*#__PURE__*/React.createElement("p", null, "Simple monthly payments")), /*#__PURE__*/React.createElement(Styled.CarePriceWrapper, null, /*#__PURE__*/React.createElement(Price, {
    quantity: quantity,
    price: price,
    isMonthlyCare: isMonthlyCare,
    dataTest: dataTest,
    direction: "row"
  }), /*#__PURE__*/React.createElement("p", {
    direction: "row"
  }, isMonthlyCare ? 'Per Month' : 'One-off payment'))), !isMonthlyCare && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Styled.CheckboxWrapper, {
    className: "xs-12--none"
  }, /*#__PURE__*/React.createElement(CheckboxItem, {
    name: "policy-accept",
    id: "policy-accept",
    checked: termCheck,
    onChange: function onChange() {
      return setTermCheck(!termCheck);
    },
    label: /*#__PURE__*/React.createElement(ProductCareSelectedCheckboxLink, {
      links: careData.links,
      dataTest: dataTest,
      careType: careData.type
    }),
    hasBackground: false
  })), /*#__PURE__*/React.createElement(Button, {
    partNumber: partNumber,
    isEnabled: termCheck,
    onClick: onClickAddItem,
    onTrolleyRequestSuccess: function onTrolleyRequestSuccess() {
      window.location.href = '/basket';
    },
    disableOnComplete: true,
    disableRecommendations: true,
    full: true
  }, "Continue with insurance")), isMonthlyCare && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Alert, {
    kind: "info",
    isCloseable: false,
    "data-test": "".concat(dataTest, "-alert"),
    className: "monthlyAlert"
  }, "To add monthly care, buy your item first and add after your order is confirmed."), !hideMonthlyCareCTA && /*#__PURE__*/React.createElement(BoltButton, {
    onClick: onClickAddMonthly,
    full: true,
    "data-test": "".concat(dataTest, "-monthly-care-button")
  }, "Continue & add after checkout")), /*#__PURE__*/React.createElement("a", {
    href: isMonthlyCare ? careData.links.ipid : '/help/argos-care',
    target: "_blank",
    "data-test": "".concat(dataTest, "-IPID-link"),
    onClick: handleIPDClick,
    rel: "noopener"
  }, isMonthlyCare ? 'T&C’s apply, find out more' : 'Find out more'));
};
WarrantyItem.propTypes = {
  partNumber: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  itemType: PropTypes.oneOf(['normal', 'primary', 'extra', 'warranty']),
  moduleIndex: PropTypes.number,
  quantity: PropTypes.number,
  trackingOptions: PropTypes.shape({
    page: PropTypes.string,
    pageId: PropTypes.string,
    placement: PropTypes.string,
    innerPlacement: PropTypes.string,
    sectionTitle: PropTypes.string,
    strategy: PropTypes.string
  }),
  onClick: PropTypes.func,
  careData: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    placement: PropTypes.string,
    model: PropTypes.string,
    links: PropTypes.shape({
      ipid: PropTypes.string,
      ipid_mob: PropTypes.string,
      leaflet: PropTypes.string,
      leaflet_mob: PropTypes.string
    })
  })
};
WarrantyItem.defaultProps = {
  itemType: 'normal',
  trackingOptions: {},
  onClick: function onClick() {},
  hideMonthlyCareCTA: false
};
export var mapStateToProps = function mapStateToProps(state, props) {
  var _flatten = flatten(state),
      trolleyItems = _flatten.trolleyItems;

  var addedTrolleyItems = trolleyItems && trolleyItems.added || [];
  return {
    isComplete: addedTrolleyItems.includes(props.partNumber)
  };
};
export default connect(mapStateToProps, _objectSpread({}, actions))(WarrantyItem);